const q = require('queried');

const likelyWidget = function ({
  url = window.location.href,
}) {
  const encodedUrl = encodeURIComponent(url);

  return `
    <div class="likely likely_visible likely_ready" data-title="Премия KudaGo">
      <a target="_blank" href="http://vkontakte.ru/share.php?url=${encodedUrl}" class=" likely__widget likely__widget_vkontakte" tabindex="0" role="link">
        <span class="likely__icon likely__icon_vkontakte">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M7.828 12.526h.957s.288-.032.436-.19c.14-.147.14-.42.14-.42s-.02-1.284.58-1.473c.59-.187 1.34 1.24 2.14 1.788.61.42 1.07.33 1.07.33l2.14-.03s1.12-.07.59-.95c-.04-.07-.3-.65-1.58-1.84-1.34-1.24-1.16-1.04.45-3.19.98-1.31 1.38-2.11 1.25-2.45-.11-.32-.84-.24-.84-.24l-2.4.02s-.18-.02-.31.06-.21.26-.21.26-.38 1.02-.89 1.88C10.27 7.9 9.84 8 9.67 7.88c-.403-.26-.3-1.053-.3-1.62 0-1.76.27-2.5-.52-2.69-.26-.06-.454-.1-1.123-.11-.86-.01-1.585.006-1.996.207-.27.135-.48.434-.36.45.16.02.52.098.71.358.25.337.24 1.09.24 1.09s.14 2.077-.33 2.335c-.33.174-.77-.187-1.73-1.837-.49-.84-.86-1.78-.86-1.78s-.07-.17-.2-.27c-.15-.11-.37-.15-.37-.15l-2.29.02s-.34.01-.46.16c-.11.13-.01.41-.01.41s1.79 4.19 3.82 6.3c1.86 1.935 3.97 1.81 3.97 1.81z"></path>
          </svg>
        </span>
      </a>
      <a target="_blank" href="https://t.me/share/url?url=${encodedUrl}" class="likely__widget likely__widget_telegram" tabindex="0" role="link">
        <span class="likely__icon likely__icon_telegram">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0
            16 16">
            <path d="M6,11.960784l-1,-3l11,-8l-15.378,5.914c0,0 -0.672,0.23 -0.619,0.655c0.053,0.425 0.602,0.619 0.602,0.619l3.575,1.203l1.62,5.154l2.742,-2.411l-0.007,-0.005l3.607,2.766c0.973,0.425 1.327,-0.46 1.327,-0.46l2.531,-13.435l-10,11zz"></path>
          </svg>
        </span>
      </a>
    </div>
  `;
};

likelyWidget.getOgProp = (prop) => {
  const metaEl = q(`meta[property="og:${prop}"]`);
  return metaEl ? encodeURIComponent(metaEl.getAttribute('content') || '') : '';
};

module.exports = likelyWidget;
